import type { ConversationMessage } from '@chronosphereio/ai';
import React, { createContext, ReactNode, useContext } from 'react';
import type { QuerySuggestion } from '@/prometheus-plugin/ai/query-assistant-context';

export type OnSuggestQueryFn = (args: {
  input: string;
  existingQuery?: string;
  history?: ConversationMessage[];
  abortSignal?: AbortSignal;
}) => Promise<QuerySuggestion>;

export interface DataQueryEditorContextValue {
  onSuggestQuery?: OnSuggestQueryFn;
}

const DataQueryEditorContext = createContext<DataQueryEditorContextValue | undefined>(undefined);

export interface DataQueryEditorProviderProps {
  children: ReactNode;
  onSuggestQuery?: OnSuggestQueryFn;
}

export const DataQueryEditorProvider = ({ children, onSuggestQuery }: DataQueryEditorProviderProps) => {
  const contextValue: DataQueryEditorContextValue = {
    onSuggestQuery,
  };

  return <DataQueryEditorContext.Provider value={contextValue}>{children}</DataQueryEditorContext.Provider>;
};

export const useDataQueryEditor = (): DataQueryEditorContextValue | undefined => {
  const context = useContext(DataQueryEditorContext);

  return context;
};
